import { apiRequest } from "./request";
import { INotification } from "@/types/notification";

const saveNotification = (data: Partial<INotification>, id?: string) =>
    apiRequest<INotification>(
        id ? `/notifications/${id}` : "/notifications",
        id ? "PATCH" : "POST",
        data,
    );

const getPendingNotifications = () =>
    apiRequest<INotification[]>("/notifications/pending", "GET");

const validateNotification = (data: {
    notificationId: string;
    type: "abandoned_cart" | "low_balance";
}) => apiRequest<{ canShow: boolean }>("/notifications/validate", "POST", data);

const markNotificationShown = (notificationId: string) =>
    apiRequest<void>(`/notifications/${notificationId}/seen`, "PATCH");

const createNotification = (data: {
    type: "abandoned_cart" | "low_balance";
    expiresAt: Date;
    sentAt: Date;
    metadata?: Record<string, any>;
}) => apiRequest<INotification>("/notifications", "POST", data);

export default {
    saveNotification,
    getPendingNotifications,
    validateNotification,
    markNotificationShown,
    createNotification,
};
